import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-sound-on.tsx
/**
* icon.24.sound.on
*
* Keywords: speaker, audio, volume, sound-waves, broadcast, loudspeaker
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJtOSAxNSAyIDIgMSAxVjZsLTEgMS0yIDJINi41YS41LjUgMCAwIDAtLjUuNXY1YS41LjUgMCAwIDAgLjUuNXptMi4yOTMtOS43MDdMOC41ODYgOEg2LjVBMS41IDEuNSAwIDAgMCA1IDkuNXY1QTEuNSAxLjUgMCAwIDAgNi41IDE2aDIuMDg2bDIuNzA3IDIuNzA3QTEgMSAwIDAgMCAxMyAxOFY2YTEgMSAwIDAgMC0xLjcwNy0uNzA3bTMuMjQ5IDEyLjEwOWMtLjI4OS4wNTUtLjU0Mi0uMTc4LS41NDItLjQ3MnYtLjAxYzAtLjI1NS4xOTMtLjQ2Ni40NDItLjUxOWE0LjUwMiA0LjUwMiAwIDAgMCAwLTguODAyLjU0LjU0IDAgMCAxLS40NDItLjUydi0uMDFjMC0uMjkzLjI1My0uNTI2LjU0Mi0uNDdhNS41MDIgNS41MDIgMCAwIDEgMCAxMC44MDJtLjAyLTIuMDY2Yy0uMjkuMDkyLS41NjItLjE0NC0uNTYyLS40NDh2LS4wM2MwLS4yMzcuMTctLjQzNy4zOTItLjUyMmEyLjUgMi41IDAgMCAwIDAtNC42NzJDMTQuMTcgOS41NzkgMTQgOS4zNzkgMTQgOS4xNHYtLjAyOWMwLS4zMDQuMjcyLS41NC41NjItLjQ0OGEzLjUwMiAzLjUwMiAwIDAgMSAwIDYuNjcybS4wMjYtMi4zMDNjLS4yMzguMjUtLjU4OC4wMi0uNTg4LS4zMjV2LTEuNDE2YzAtLjM0NS4zNS0uNTc1LjU4OC0uMzI1YTEuNSAxLjUgMCAwIDEgMCAyLjA2NiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1821
*/
const Icon24SoundOn = memo(function Icon24SoundOn(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "m9 15 2 2 1 1V6l-1 1-2 2H6.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5zm2.293-9.707L8.586 8H6.5A1.5 1.5 0 0 0 5 9.5v5A1.5 1.5 0 0 0 6.5 16h2.086l2.707 2.707A1 1 0 0 0 13 18V6a1 1 0 0 0-1.707-.707m3.249 12.109c-.289.055-.542-.178-.542-.472v-.01c0-.255.193-.466.442-.519a4.502 4.502 0 0 0 0-8.802.54.54 0 0 1-.442-.52v-.01c0-.293.253-.526.542-.47a5.502 5.502 0 0 1 0 10.802m.02-2.066c-.29.092-.562-.144-.562-.448v-.03c0-.237.17-.437.392-.522a2.5 2.5 0 0 0 0-4.672C14.17 9.579 14 9.379 14 9.14v-.029c0-.304.272-.54.562-.448a3.502 3.502 0 0 1 0 6.672m.026-2.303c-.238.25-.588.02-.588-.325v-1.416c0-.345.35-.575.588-.325a1.5 1.5 0 0 1 0 2.066",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24SoundOn };

//# sourceMappingURL=icon-24-sound-on.js.map